import './textArea.css';

const TextArea = ({ label, labelInstruction, value, onChange, placeholder, maxLength, name }) => {
  return (
    <div className="input-text">
      {label ?
        <label className="input-label">{label}</label>
        :
        ''
      }
      {labelInstruction ?
        <label className="input-instruction">{labelInstruction}</label>
        :
        ''
      }
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="textarea"
        maxLength={maxLength}
      />
    </div>
  );
};

export default TextArea;
